import React from 'react';
// import './App.css';
import { Provider } from 'react-redux';
import Routes from './app/routes'
import store from './app/store';
import StyledThemeProvider from './components/StyledThemeProvider'
// import { SnackbarProvider } from 'notistack';
import Notifier from './components/Notifier'
import PackPlayer from './features/common/PackPlayer'

const isReactSnapshot = () => typeof window !== 'undefined' && window.reactSnapshotRender


const App = () => {
  const snapshot = isReactSnapshot()

  return (
    <Provider store={store}>
      <StyledThemeProvider scope="app">
        {/* <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'center', vertical: 'top' }} autoHideDuration={3000}> */}
          {!snapshot && <Notifier />}
          <Routes />
          {!snapshot && <PackPlayer />}
        {/* </SnackbarProvider> */}
      </StyledThemeProvider>
    </Provider>
  )
};

export default App;
